import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/',
    component: () => import('@/views/Admin/Index.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'users',
        name: 'User-Settings',
        component: () => import('@/views/Admin/Users.vue'),
      },
      {
        path: 'organisations',
        name: 'Organisations-Settings',
        component: () => import('@/views/Admin/Organisations.vue'),
      },
      {
        path: 'devices',
        name: 'Devices-Settings',
        component: () => import('@/views/Admin/Devices.vue'),
      },
      { path: '', redirect: 'users' },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
